/*
 * The no-pollution module is a stopgap fix until we can upgrade our lodash to
 * the latest 4 version. Once that is done this module can be removed.
 * Torin - 3/30/20
 */
import 'no-pollution';

import { initializeLocaleBundle } from './i18n/IntlLocaleBundle';

/* eslint-disable no-undef -- defined by webpack */
window.churroVersion = VERSION; // This comes from webpack DefinePlugin
window.churroBranch = GIT_BRANCH_NAME;
window.churroCommit = GIT_COMMIT_HASH;
/* eslint-enable no-undef */

if (!process.env.CHURRO_SHELL) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = window.burroUrl + '/churro/current/dist/';
}

function createNoExtEnvironmentObjects() {
  const RALLY = { sso: {} };
  // populated at run-time with constants
  RALLY.sso.SsoAuthenticationPolicies = {};
  // populated at run-time with current session info
  RALLY.sso.CurrentSsoConfig = null;

  RALLY.sso.Config = function (url, policy, isSsoLoggedIn) {
    this.url = url;
    this.policy = policy;
    this.isSsoLoggedIn = isSsoLoggedIn;
  };

  RALLY.sso.Config.prototype = {
    isSsoSession: function () {
      return this.isSsoLoggedIn;
    },
  };

  const noExtMessageBus = {
    publish: () => {
      //do nothing on NO_EXTJS mode
    },
  };

  const noExtContext = {};
  const Rally = {
    environment: {
      getMessageBus: () => noExtMessageBus,
      getContext: () => noExtContext,
    },
  };

  return {
    RALLY,
    Rally,
  };
}

function bootstrap() {
  window.performance.mark('churroBootstrapStart');
  const config = window.envConfig,
    navModel = window.navModel;

  if (window.FEATURE_TOGGLES && !window.FEATURE_TOGGLES.NO_EXTJS) {
    window.performance.mark('pinataBundleStart');
    window.pinataBundlePromise = fetchPinataLanguageBundle(config).then(
      (data) => {
        window.performance.mark('pinataBundleEnd');
        return data.text();
      },
    );
  } else {
    const { RALLY, Rally } = createNoExtEnvironmentObjects();
    window.RALLY = { ...RALLY, ...window.RALLY };
    window.Rally = { ...Rally, ...window.Rally };
    window.pinataBundlePromise = Promise.resolve('{"messages":{}}');
  }

  window.churroBootstrapPromise = initializeLocaleBundle(config)
    .then(
      () => import(/* webpackChunkName: "churro-main" */ './viewport/index.js'),
    )
    .then(function (churroSite) {
      const site = churroSite.buildSite(config, navModel);
      window.Churro = site.publicExports || site;
      site.renderLocalizedSite(document.getElementById('root'));
      window.performance.mark('churroBootstrapEnd');
    });
}

function fetchPinataLanguageBundle(config) {
  const language = config.globalContext.user.UserProfile.Language;
  return fetch(getPinataBundleURL(config.contextPath, language));
}

function getPinataBundleURL(contextPath, locale) {
  const fileName = 'pinata-resources_' + locale.replace('-', '_') + '.json';
  const hashes = window.PINATA_RESOURCE_HASHES;
  const cacheBuster = hashes && hashes[fileName];

  return `${contextPath}/js-lib/rui/builds/rui/resources/locale-data/${fileName}?cb=${
    cacheBuster || Date.now()
  }`;
}

bootstrap();
